export default __webpack_public_path__ + "static/media/Level39.2e433286.svg";